{
  "apps.scope.label": "Current application",
  "apps.scope.placeholder": "Select an application",
  "apps.scope.required": "Select an application from the page header to manage its data.",
  "apps.status.active": "Active",
  "apps.status.disabled": "Disabled",
  "apps.actions.enable": "Enable",
  "apps.actions.disable": "Disable",
  "apps.client_config.actions.open": "Client configuration",
  "apps.client_config.title": "Client configuration",
  "apps.client_config.tabs.share": "Sharing",
  "apps.client_config.tabs.scanner": "Scanner",
  "apps.client_config.unsaved.title": "Discard unsaved client configuration?",
  "apps.client_config.unsaved.description": "One or more configuration tabs contain unsaved changes. Closing will discard them.",
  "apps.client_config.unsaved.discard": "Discard changes",
  "apps.client_config.scanner.runtime_title": "Scanner web security boundary",
  "apps.client_config.scanner.runtime_description": "Only absolute HTTPS addresses matching the allowlist can open in the App. This runtime configuration takes effect only after the client refreshes it successfully.",
  "apps.client_config.scanner.enabled": "Allow scanned web pages to open in the App",
  "apps.client_config.scanner.enabled_help": "When disabled, host entries are retained but every scan result is presented inside the App.",
  "apps.client_config.scanner.allowed_hosts": "Allowed domains",
  "apps.client_config.scanner.allowed_hosts_help": "Supports example.com and *.example.com. A wildcard matches any subdomain depth but not the root. Schemes, paths, IPs, localhost, non-443 ports, and public-suffix wildcards are rejected.",
  "apps.client_config.scanner.host_required": "Add at least one allowed domain before enabling in-App web pages.",
  "apps.client_config.scanner.host_label": "Allowed domain row {index}",
  "apps.client_config.scanner.host_invalid": "Enter a valid ASCII/Punycode exact domain or wildcard domain.",
  "apps.client_config.scanner.remove_host": "Remove allowed domain row {index}",
  "apps.client_config.scanner.empty_hosts": "No allowed domains have been added.",
  "apps.client_config.scanner.add_host": "Add domain",
  "apps.client_config.scanner.saved": "Scanner configuration saved.",
  "apps.client_config.scanner.load_error": "Scanner configuration could not be loaded.",
  "apps.client_config.scanner.save_error": "Scanner configuration could not be saved. Check the input and try again.",
  "apps.client_config.scanner.conflict": "Someone else updated this configuration. The latest version has been loaded; review your changes again.",
  "apps.locale.zh-CN": "Simplified Chinese",
  "apps.locale.en-US": "English",
  "apps.registration.enabled": "Registration open",
  "apps.registration.disabled": "Registration closed",
  "apps.registration.verification.none": "No verification",
  "apps.registration.verification.email_otp": "Email verification code",
  "apps.membership.pending_verification": "Pending email verification",
  "apps.membership.active": "Enabled",
  "apps.membership.disabled": "Disabled",
  "apps.values.none": "None",
  "apps.feedback.load_error": "Could not load App management data. Try again.",
  "apps.feedback.save_error": "Could not save the change. Try again.",
  "apps.feedback.validation_error": "Check and correct the form fields.",
  "apps.feedback.saved": "Saved.",
  "apps.feedback.status_saved": "Status updated.",
  "apps.feedback.deleted": "Deleted.",
  "apps.feedback.conflict": "Another administrator changed this application. Refresh and try again.",
  "apps.application.title": "Application management",
  "apps.application.description": "Create and configure independent mobile application boundaries for the current workspace.",
  "apps.application.actions.create": "Create application",
  "apps.application.actions.add_channel": "Add distribution channel",
  "apps.application.actions.add_screenshot": "Add screenshot",
  "apps.application.actions.add_store": "Add app store",
  "apps.application.actions.batch_delete": "Delete selected ({count})",
  "apps.application.actions.choose_icon": "Choose app icon",
  "apps.application.actions.choose_qrcode": "Choose QR code",
  "apps.application.actions.content": "Content",
  "apps.application.actions.move_down": "Move down",
  "apps.application.actions.move_up": "Move up",
  "apps.application.actions.menu": "Actions",
  "apps.application.actions.menu_for": "Actions for {name}",
  "apps.application.actions.upgrade_center": "Upgrade center",
  "apps.application.sections.startup": "Startup",
  "apps.startup.actions.add_slide": "Add onboarding image",
  "apps.startup.actions.choose_image": "Choose image",
  "apps.startup.actions.publish": "Publish new version",
  "apps.startup.bundle_export_hint": "Export the bundled startup snapshot before releasing the App. Saving here does not change the first-run privacy screen in an installed build.",
  "apps.startup.draft_changed": "Draft changed",
  "apps.startup.draft_synced": "Matches published version",
  "apps.startup.feedback.asset_rejected": "An image has not passed scanning or is not JPEG, PNG, or WebP.",
  "apps.startup.feedback.published": "A new onboarding version was published.",
  "apps.startup.fields.accessibility_label": "Accessibility description",
  "apps.startup.fields.display_name": "Startup display name",
  "apps.startup.fields.enabled": "Show onboarding at startup",
  "apps.startup.fields.subtitle": "Startup subtitle",
  "apps.startup.icon_preview": "Application icon preview",
  "apps.startup.image_preview": "Onboarding image {index} preview",
  "apps.startup.image_required": "Choose an image that passed scanning",
  "apps.startup.publish.description": "All localized images will be validated and copied into an immutable version. Users who completed an older version will see this one.",
  "apps.startup.publish.title": "Publish a new onboarding version?",
  "apps.startup.published_version": "Published version v{version}",
  "apps.startup.slide": "Onboarding position {index}",
  "apps.application.channel_card": "Channel {index}",
  "apps.application.empty": "No applications",
  "apps.application.filters.q": "Search applications",
  "apps.application.filters.landmark": "Application filters",
  "apps.application.filters.status": "Application status",
  "apps.application.filters.type": "Application type",
  "apps.application.columns.appid": "AppID",
  "apps.application.columns.created": "Created",
  "apps.application.columns.description": "Description",
  "apps.application.columns.name": "Application",
  "apps.application.columns.remark": "Remark",
  "apps.application.columns.registration": "Registration",
  "apps.application.columns.status": "Status",
  "apps.application.columns.type": "Application type",
  "apps.application.columns.updated": "Updated",
  "apps.application.columns.actions": "Actions",
  "apps.application.delete.title": "Delete the selected applications?",
  "apps.application.delete.description": "Only disabled, non-default applications can be deleted. Batch deletion is all-or-nothing.",
  "apps.application.editor.create": "Create application",
  "apps.application.editor.edit": "Edit application",
  "apps.application.fields.abm_url": "iOS ABM sign-in URL",
  "apps.application.fields.app_type": "Application type",
  "apps.application.fields.appid": "Manifest AppID",
  "apps.application.fields.appid_hint": "Immutable after it is set, for example __UNI__APPKERNIA.",
  "apps.application.fields.channel_code": "Channel",
  "apps.application.fields.channel_name": "Channel application name",
  "apps.application.fields.channel_url": "Download or access URL",
  "apps.application.fields.name": "Application name",
  "apps.application.fields.default_locale": "Default locale",
  "apps.application.fields.description": "Description",
  "apps.application.fields.introduction": "Introduction",
  "apps.application.fields.managers": "Administrators",
  "apps.application.fields.members": "Members",
  "apps.application.fields.owner_id": "Owner",
  "apps.application.fields.owner_type": "Owner type",
  "apps.application.fields.registration_enabled": "Allow self-service registration",
  "apps.application.fields.registration_verification": "Registration verification",
  "apps.application.fields.registration_verification_mode": "Registration verification",
  "apps.application.fields.remark": "Remark",
  "apps.application.fields.store_enabled": "Enable this store",
  "apps.application.fields.store_name": "Store name",
  "apps.application.fields.store_priority": "Priority",
  "apps.application.fields.store_scheme": "Application scheme",
  "apps.application.fields.uuid_list_hint": "Enter one UUID per line. Team metadata does not change RBAC authorization.",
  "apps.application.owner_types.tenant": "Tenant",
  "apps.application.owner_types.user": "Individual user",
  "apps.application.sections.assets": "Icon",
  "apps.application.sections.basic": "Basic information",
  "apps.application.sections.channels": "Channels",
  "apps.application.sections.owner_team": "Owner and team",
  "apps.application.sections.stores": "App stores",
  "apps.application.store_card": "App store {index}",
  "apps.application.types.uni_app": "uni-app",
  "apps.application.types.uni_app_x": "uni-app x",
  "apps.application.validation.appid": "AppID may contain only letters, digits, dots, underscores, and hyphens.",
  "apps.application.values.appid_pending": "Pending configuration",
  "apps.application.values.none": "Not set",
  "apps.application.channels.android": "Android",
  "apps.application.channels.ios": "iOS",
  "apps.application.channels.harmony": "HarmonyOS Next",
  "apps.application.channels.h5": "H5",
  "apps.application.channels.quickapp": "Quick App",
  "apps.application.channels.mp_weixin": "WeChat Mini Program",
  "apps.application.channels.mp_alipay": "Alipay Mini Program",
  "apps.application.channels.mp_baidu": "Baidu Smart Program",
  "apps.application.channels.mp_toutiao": "Douyin Mini Program",
  "apps.application.channels.mp_qq": "QQ Mini Program",
  "apps.application.channels.mp_kuaishou": "Kuaishou Mini Program",
  "apps.application.channels.mp_lark": "Lark Mini Program",
  "apps.application.channels.mp_jd": "JD Mini Program",
  "apps.application.channels.mp_dingtalk": "DingTalk Mini Program",
  "apps.users.title": "App user management",
  "apps.users.description": "Only people explicitly associated with the current application are listed; shared account infrastructure still owns identity.",
  "apps.users.actions.create": "Create user",
  "apps.users.actions.unlock": "Unlock",
  "apps.users.actions.reset-password": "Reset password",
  "apps.users.actions.revoke-sessions": "Revoke mobile sessions",
  "apps.users.empty": "No users for this application",
  "apps.users.filters.landmark": "App user filters",
  "apps.users.filters.q": "Search name or email",
  "apps.users.filters.status": "Membership status",
  "apps.users.avatar_alt": "Avatar for {name}",
  "apps.users.avatar_self_managed": "Users manage their own avatar in the mobile app.",
  "apps.users.columns.user": "User",
  "apps.users.columns.source": "Source",
  "apps.users.columns.status": "Status",
  "apps.users.columns.last_sign_in": "Last sign-in",
  "apps.users.columns.actions": "Actions",
  "apps.users.source.self_registration": "Self registration",
  "apps.users.source.admin_created": "Admin created",
  "apps.users.source.legacy": "Legacy migration",
  "apps.users.editor.create": "Create App user",
  "apps.users.editor.edit": "Edit App user",
  "apps.users.fields.email": "Email",
  "apps.users.fields.display_name": "Display name",
  "apps.users.fields.password": "Initial password",
  "apps.users.fields.password_hint": "At least 12 characters; it is never shown again after saving.",
  "apps.users.fields.status": "Membership status",
  "apps.users.fields.locale": "Locale preference",
  "apps.users.password_reset.title": "Reset App user password",
  "apps.users.password_reset.description": "Set a new sign-in password for “{name}”. The server applies its security policy to existing mobile sessions.",
  "apps.users.password_reset.new_password": "New password",
  "apps.users.password_reset.confirm_password": "Confirm new password",
  "apps.users.feedback.password_reset": "Password reset.",
  "apps.users.confirm.enable.title": "Enable this user?",
  "apps.users.confirm.enable.description": "This allows “{name}” to use the current application.",
  "apps.users.confirm.disable.title": "Disable this user?",
  "apps.users.confirm.disable.description": "This blocks “{name}” from using the current application.",
  "apps.users.confirm.unlock.title": "Unlock this user?",
  "apps.users.confirm.unlock.description": "This clears the sign-in lock on “{name}” .",
  "apps.users.confirm.reset-password.title": "Reset this user's password?",
  "apps.users.confirm.reset-password.description": "This starts a secure password reset flow for “{name}” .",
  "apps.users.confirm.revoke-sessions.title": "Revoke mobile sessions?",
  "apps.users.confirm.revoke-sessions.description": "The current application's mobile sessions for “{name}” become invalid immediately.",
  "apps.pages.title": "Single pages",
  "apps.pages.description": "Maintain bilingual drafts, publishing, and revision history for legal, About, and custom pages.",
  "apps.pages.actions.create": "Create single page",
  "apps.pages.actions.publish": "Publish",
  "apps.pages.empty": "No single pages",
  "apps.pages.reserved": "Protected",
  "apps.pages.reserved_hint": "A core page identifier cannot be changed or deleted.",
  "apps.pages.filters.landmark": "Single page filters",
  "apps.pages.filters.q": "Search single pages",
  "apps.pages.columns.title": "Title",
  "apps.pages.columns.type": "Type",
  "apps.pages.columns.status": "Status",
  "apps.pages.columns.updated": "Updated",
  "apps.pages.columns.actions": "Actions",
  "apps.pages.type.privacy-policy": "Privacy policy",
  "apps.pages.type.terms-of-service": "Terms of service",
  "apps.pages.type.about-us": "About us",
  "apps.pages.type.custom": "Custom page",
  "apps.pages.status.draft": "Draft",
  "apps.pages.status.published": "Published",
  "apps.pages.editor.create": "Create single page",
  "apps.pages.editor.edit": "Edit single page",
  "apps.pages.fields.slug": "Path identifier",
  "apps.pages.fields.type": "Content type",
  "apps.pages.fields.title": "Title",
  "apps.pages.fields.body": "Body",
  "apps.pages.fields.body_format": "Body format",
  "apps.pages.fields.blocks": "Structured content (JSON)",
  "apps.pages.fields.blocks_hint": "Only heading, paragraph, quote, code, image, list, and divider blocks are supported.",
  "apps.pages.body_format.markdown": "Markdown",
  "apps.pages.body_format.blocks": "Structured content",
  "apps.pages.feedback.published": "Single page published.",
  "apps.pages.feedback.save_before_publish": "Edit and save the complete bilingual content before publishing this page.",
  "apps.pages.delete.title": "Delete this single page?",
  "apps.pages.delete.description": "This deletes “{name}” and its draft content; published revisions remain server-audited.",
  "apps.pages.type.faq": "FAQ",
  "apps.pages.type.contact-support": "Contact support",
  "apps.feedbacks.title": "Feedback",
  "apps.feedbacks.description": "Review feedback for the selected App, update progress and reply to users.",
  "apps.feedbacks.filters": "Feedback filters",
  "apps.feedbacks.search": "Search descriptions",
  "apps.feedbacks.status": "Status",
  "apps.feedbacks.all": "All statuses",
  "apps.feedbacks.dateRange": "Submission date range",
  "apps.feedbacks.failed": "The operation failed. Try again.",
  "apps.feedbacks.empty": "No feedback found.",
  "apps.feedbacks.content": "Description",
  "apps.feedbacks.platform": "Platform",
  "apps.feedbacks.version": "App version",
  "apps.feedbacks.created": "Submitted at",
  "apps.feedbacks.detail": "Feedback details",
  "apps.feedbacks.image": "Feedback screenshot",
  "apps.feedbacks.imageRetry": "Reload screenshot",
  "apps.feedbacks.conflict": "This feedback was updated. Your input has been kept; refresh and try again.",
  "apps.feedbacks.refresh": "Refresh details",
  "apps.feedbacks.replyRequired": "Enter a reply of 1–2,000 characters.",
  "apps.feedbacks.user": "User ID",
  "apps.feedbacks.contact": "Contact details",
  "apps.feedbacks.notProvided": "Not provided",
  "apps.feedbacks.markStatus": "Mark as {status}",
  "apps.feedbacks.replies": "Replies",
  "apps.feedbacks.noReply": "No replies yet.",
  "apps.feedbacks.reply": "Reply",
  "apps.feedbacks.replyStatus": "Status after reply",
  "apps.feedbacks.sendReply": "Send reply",
  "apps.feedbacks.history": "Status history",
  "apps.feedbacks.status.pending": "Pending",
  "apps.feedbacks.status.processing": "In progress",
  "apps.feedbacks.status.resolved": "Resolved",
  "apps.feedbacks.platform.android": "Android",
  "apps.feedbacks.platform.ios": "iOS",
  "apps.feedbacks.platform.harmony": "HarmonyOS",
  "apps.feedbacks.platform.unknown": "Unknown",
  "apps.public_web.title": "Public download page",
  "apps.public_web.enabled": "Publish download page",
  "apps.public_web.apk_enabled": "Allow Android APK downloads",
  "apps.public_web.promotion_enabled": "Show download promotion",
  "apps.public_web.promotion_section": "H5 download promotion",
  "apps.public_web.promotion_hint": "Controls the download link in the header and the promotion after articles and pages. Empty fields use the app name and built-in copy.",
  "apps.public_web.promotion_title": "Promotion title",
  "apps.public_web.promotion_description": "Promotion description",
  "apps.public_web.promotion_button_label": "Promotion button label",
  "apps.public_web.name": "App display name",
  "apps.public_web.introduction": "App introduction",
  "apps.public_web.platform": "Platform",
  "apps.public_web.web_url": "Store HTTPS URL",
  "apps.public_web.unset": "Not configured",
  "apps.public_web.view": "View public page",
  "apps.public_web.copy": "Copy public link",
  "apps.public_web.qr": "Download page QR code",
  "apps.public_web.hint": "Platform detection happens on the download page. Stores without a platform and HTTPS URL are omitted; APKs must be published in the upgrade center.",
  "apps.public_web.origin_missing": "The server has no public web origin configured. Publishing is unavailable.",
  "apps.public_web.validation": "Provide a name and introduction in both languages and check store platforms and HTTPS URLs.",
  "apps.public_web.copied": "Link copied",
  "apps.public_web.copy_error": "Copy failed. Please copy the link manually.",
  "apps.public_web.not_published": "Only published content can be viewed.",
  "apps.public_web.preview": "Mobile preview",
  "apps.public_web.preview_refresh": "Refresh preview",
  "apps.public_web.preview_close": "Close preview",
  "apps.public_web.preview_hint": "Appearance and size preview only. Platform detection uses your current browser.",
  "apps.public_web.preview_frame": "Mobile preview of {name}",
  "apps.public_web.preview_loading": "Loading public page…",
  "apps.public_web.preview_timeout": "Unable to confirm page loading. Retry or open it separately.",
  "apps.client_config.tabs.login_providers": "Sign-in",
  "apps.client_config.login.title": "Sign-in methods",
  "apps.client_config.login.description": "Password sign-in is always available. OTP settings apply to sign-in, registration, and password recovery. Provider access is configured below.",
  "apps.client_config.login.methods_title": "Basic sign-in methods",
  "apps.client_config.login.password": "Password sign-in",
  "apps.client_config.login.password_help": "Enabled by default and cannot be turned off.",
  "apps.client_config.login.otp": "Verification code sign-in",
  "apps.client_config.login.email_otp": "Email code",
  "apps.client_config.login.sms_otp": "SMS code",
  "apps.client_config.login.channel_required": "Enable at least email or SMS when verification code sign-in is on.",
  "apps.client_config.login.saved": "Sign-in configuration saved.",
  "apps.client_config.login.load_error": "Sign-in configuration could not be loaded.",
  "apps.client_config.login.save_error": "Sign-in configuration could not be saved. Refresh and try again.",
  "apps.users.actions.delete": "Delete user",
  "apps.users.confirm.delete.title": "Delete this user?",
  "apps.users.confirm.delete.description": "Delete “{name}” from “{app}”, erase associated data and immediately invalidate their sessions for this App. This cannot be undone.",
  "apps.users.confirm.delete.retention": "Other Apps, payment and wallet relations are retained under the account deletion rules. Audit and legal consent records are anonymized. Exclusive files are erased in the background; shared files are retained with personal associations removed.",
  "apps.users.feedback.deleted": "User deleted. Associated exclusive files will be erased in the background.",
  "apps.users.feedback.delete_error": "Deletion failed. Please try again.",
  "apps.client_config.login.web_qr": "App QR sign-in for website members",
  "apps.client_config.login.web_qr_help": "Let signed-in users of this App approve website member sign-ins. Independent of staff Admin QR sign-in."
}
